import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class Twitter implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_TWITTER;
  label: string = 'Twitter Pixel';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = true;

  getClientIdRegexp(): RegExp {
    return /^[a-zA-Z0-9]{5}$/;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
